<template>
  <b-row>
    <b-col cols="12">
      <b-btn class="viewmembers-btn" variant="outline-primary" @click.stop="memberList()">Member List</b-btn>
      <b-button class="logout-btn" variant="outline-danger" v-on:click="logout">Logout</b-button>

      <div class="welcome-message">
        Currently logged in as:  <b>{{ getCurrentUser() }}</b>
      </div>

      <b-jumbotron class="bulletin-section" bg-variant="white" border-variant="black"> <!-- Bulletin section -->
        <div class="bulletin-title">
          Bulletin
        </div>
        <b-btn class="addnew-btn" variant="outline-success" @click.stop="addPost()">Add New Bulletin</b-btn><br><br>

        <b-table class="bulletin-table" sortBy="date" striped hover :items="posts" :fields="bulletinfields">
          <template slot="actions" slot-scope="row">
            <b-btn size="md" @click.stop="bulletindetails(row.item)" variant="outline-primary">Details</b-btn>
          </template>
        </b-table>
      </b-jumbotron>

      <b-jumbotron class="events-section" bg-variant="white" border-variant="black"> <!-- Events section -->
        <div class="events-title">
          Upcoming Events
        </div>
        <b-btn class="addnew-btn" variant="outline-success" @click.stop="addEvent()">Add New Event</b-btn><br><br>

        <b-table class="events-table" sortBy="eventdate" striped hover :items="events" :fields="eventfields">
          <template slot="actions" slot-scope="row">
            <b-btn size="md" @click.stop="eventdetails(row.item)" variant="outline-primary">Details</b-btn>
          </template>
        </b-table>
      </b-jumbotron>

    </b-col>
  </b-row>
</template>
<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'Dashboard',
  data () {
    return {
      bulletinfields: {
        title: { label: 'Bulletin Title', sortable: true, 'class': 'text-left' },
        date: { label: 'Date Posted', sortable: true, 'class': 'text-left'},
        actions: { label: '', 'class': 'text-center' }
      },
      eventfields: {
        eventtitle: { label: 'Event', sortable: false, 'class': 'text-left'},
        eventlocation: { label: 'Location', sortable: true, 'class': 'text-left'},
        eventdiscipline: { label: 'Discipline', sortable: true, 'class': 'text-left'},
        starttime: { label: 'Start Time', sortable: false, 'class': 'text-left'},
        endtime: { label: 'End Time', sortable: false, 'class': 'text-left'},
        eventdate: { label: 'Date', sortable: true, 'class': 'text-left'},
        actions: { label: '', 'class': 'text-center'}
      },
      posts: [],
      events: [],
      users: [],
      errors: [],
      currentUser: firebase.auth().currentUser,
      scrolled: false,

      postsDB: firebase.firestore().collection('posts'),
      usersDB: firebase.firestore().collection('users'),
      eventsDB: firebase.firestore().collection('events')
    }
  },
  created () {
    this.postsDB.onSnapshot((querySnapshot) => {
      this.posts = [];
      querySnapshot.forEach((doc) => {
        this.posts.push({
          key: doc.id,
          title: doc.data().title,
          date: doc.data().DateTime
        });
      });
    });

    this.eventsDB.onSnapshot((querySnapshot) => {
      this.events = [];
      querySnapshot.forEach((doc) => {
        this.events.push({
          key: doc.id,
          eventtitle: doc.data().title,
          eventdate: doc.data().event_date,
          starttime: doc.data().start_time,
          endtime: doc.data().end_time,
          eventlocation: doc.data().location,
          eventdiscipline: doc.data().discipline
        });
      });
    });
  },

  methods: {
    memberList() {
      router.push({ name: 'MemberList'})
    },

    addPost() {
      router.push({ name: 'AddPost'})
    },

    addEvent() {
      router.push({ name: 'AddEvent'})
    },

    bulletindetails (post) {
      router.push({ name: 'ShowPost', params: { id: post.key }})
    },

    eventdetails (event) {
      router.push({ name: 'ShowEvent', params: { id: event.key }})
    },

    getCurrentUser() {
      return this.currentUser.email;
    },

    getUid() {
        return firebase.auth().currentUser.uid;
    },

    logout: function() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('Login')
        alert('You have successfully logged out.')
      })
    }
  }
}
</script>

<style>
.bulletin-section {
  height: auto;
  margin-top: 30px;
}
.welcome-message {
  margin-top: 20px;
  font-size: 10pt;
  color: gray;
}
.events-section {
  height: auto;
  margin-top: 30px;
}
.bulletin-title {
  font-size: 20pt;
  font-weight: bold;
  font-variant: small-caps;
  margin-bottom: 40px;
  margin-top: 0px;
}
.events-title {
  font-size: 20pt;
  font-weight: bold;
  font-variant: small-caps;
  margin-bottom: 40px;
  margin-top: 0px;
}
.bulletin-table {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.events-table {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.addnew-btn {
  margin-top: -40px;
}
.viewmembers-btn {
  margin-right: 20px;
}
.logout-btn {
  text-align: center;
}
</style>